import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/filterTemplates'
import Component from 'components/FilterTemplates/Select'

export default createListModalContainer({ actions })(Component)
